// extracted by mini-css-extract-plugin
module.exports = {"collapse":"auditlog_collapse__3f01x","item":"auditlog_item__WCvPO"};